import { OneOnOneInsightsRequestI } from 'screens/oneOnOneRabbit/Insights/interfaces';
import { z } from 'zod';

import { getOneOnOneInsightsGraphDataApi } from '../api';

const OneOnOneInsightsCompletionGraphDataValidator = z.object({
  completionData: z.record(z.string(), z.number().default(0)).nullable().optional(),
  ratingData: z.record(z.string(), z.number().default(0)).nullable().optional(),
  themeSentimentData: z
    .object({
      GROWTH: z
        .object({
          totalOneOnOnes: z.number(),
          totalAgendaPoints: z.number(),
          overallSentiment: z.string(),
          overAllSentimentScore: z.number().nullable().optional(),
          sentimentDistribution: z.object({
            NEUTRAL: z.number().optional(),
            POSITIVE: z.number().optional(),
            NEGATIVE: z.number().optional(),
          }),
        })
        .nullable()
        .optional(),
      MANAGER_EFFECTIVENESS: z
        .object({
          totalOneOnOnes: z.number(),
          totalAgendaPoints: z.number(),
          overallSentiment: z.string(),
          overAllSentimentScore: z.number().nullable().optional(),
          sentimentDistribution: z.object({
            NEUTRAL: z.number().optional(),
            POSITIVE: z.number().optional(),
            NEGATIVE: z.number().optional(),
          }),
        })
        .nullable()
        .optional(),
      COLLABORATION: z
        .object({
          totalOneOnOnes: z.number(),
          totalAgendaPoints: z.number(),
          overallSentiment: z.string(),
          overAllSentimentScore: z.number().nullable().optional(),
          sentimentDistribution: z.object({
            NEUTRAL: z.number().optional(),
            POSITIVE: z.number().optional(),
            NEGATIVE: z.number().optional(),
          }),
        })
        .nullable()
        .optional(),
      BELONGING: z
        .object({
          totalOneOnOnes: z.number().nullable().optional(),
          totalAgendaPoints: z.number().nullable().optional(),
          overallSentiment: z.string().nullable().optional(),
          overAllSentimentScore: z.number().nullable().optional(),
          sentimentDistribution: z.object({
            NEUTRAL: z.number().optional(),
            POSITIVE: z.number().optional(),
            NEGATIVE: z.number().optional(),
          }),
        })
        .nullable()
        .optional(),
      PERFORMANCE: z
        .object({
          totalOneOnOnes: z.number(),
          totalAgendaPoints: z.number(),
          overallSentiment: z.string(),
          overAllSentimentScore: z.number().nullable().optional(),
          sentimentDistribution: z.object({
            NEUTRAL: z.number().optional(),
            POSITIVE: z.number().optional(),
            NEGATIVE: z.number().optional(),
          }),
        })
        .nullable()
        .optional(),
    })
    .nullable()
    .optional(),
});

export type OneOnOneInsightsCompletionGraphData = z.infer<typeof OneOnOneInsightsCompletionGraphDataValidator>;

export const getOneOnOneInsightsGraphData = async ({
  isExpandedViewRequired,
  cohort,
  dateRange,
  groupByKeys,
  orderBy,
  isShowReportees,
  isManagePage = false,
  employeeId,
}: OneOnOneInsightsRequestI) => {
  try {
    const res = await getOneOnOneInsightsGraphDataApi({
      isExpandedViewRequired,
      cohort,
      dateRange,
      groupByKeys,
      orderBy,
      isShowReportees,
      isManagePage,
      employeeId,
    });
    const validatedData = OneOnOneInsightsCompletionGraphDataValidator.parse(res.entity);
    return validatedData;
  } catch (error) {
    console.error('Error fetching one on one insights graph data : ', error);
  }
};
